import { PAGE_TYPES } from '@src/constants/page-type'

export const EXCLUDE_ZIP_CODE_FETCH_FOR_PAGE_TYPE_LIST: string[] = [PAGE_TYPES.COLLECTION, PAGE_TYPES.SUBCOLLECTION]
